<template>
  <div id="users-news-root">
    <router-view />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
